module.exports = __webpack_public_path__ + "img/01.eb56e356.jpg";